/**
 * The unread count beside Messages in the side nav (desktop and drawer).
 * Reads the shared Messages store, so it updates the moment a message lands
 * and clears as chats are read. Nothing renders at zero.
 */
import React from 'react';
import { useMessagesState, selectTotalUnread } from '../data/store';
import { useAllowedSpaces } from '../data/spaces';
import './messages-nav.css';

/** Only spaces this person can see count (no client chats for someone without client access). */
export function useMessagesUnread() {
    const spaces = useAllowedSpaces();
    return useMessagesState((s) => selectTotalUnread(s, spaces));
}

export default function MessagesNavCount() {
    const count = useMessagesUnread();
    if (!count) return null;
    return (
        <span className="bm-nav-count" aria-label={`${count} unread`}>
            {count > 99 ? '99+' : count}
        </span>
    );
}
